<template>
  <div class="home">
    <div class="home_banner">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        
        <van-swipe-item v-for="(item, index) in bannerList" :key="index">
          <img   v-lazy="item" :alt="item">
          
        </van-swipe-item>
        <!-- <img v-for="item in bannerList" :key="item.bannerId" :src="baseUrl + item.bannerUri" :alt="item.bannerName"> -->
      </van-swipe>
    </div>
   <div class="home_option">
    <div class="option_item" @click="$router.push({path: '/ordernotice', query: {btn: 1}})">
      <img  v-lazy="require('../../assets/doOrder.png')" alt="">
      <span>我要预约</span>
    </div>
    <div class="option_item" @click="$router.push('/orderlist')">
      <img  v-lazy="require(`../../assets/myOrder.png`)" alt="">
      <span>我的预约</span>
    </div>
    <div class="option_item" @click="$router.push({path: '/ordernotice', query: {btn: 0}})">
      <img  v-lazy="require(`../../assets/know.png`)" alt="">
      <span>预约须知</span>
    </div>
   </div>
   <!-- <div class="home_bottom"></div> -->
  </div>
</template>

<script>
import { getBanner } from '@/api/user'
export default {
  data () {
    return {
      bannerList: [
        require('../../assets/banner_01.jpg'),
        require('../../assets/banner_02.jpg'),
        require('../../assets/banner_03.jpg'),
      ],
      baseUrl: process.env.VUE_APP_API_BASE_URL == '/' ? location.origin : process.env.VUE_APP_API_BASE_URL,
    }
  },
  created () {
    // this.getBanner()
  },
  methods: {
    // 获取Banner
    getBanner () {
      getBanner({status: 1}).then(res => {
        if(res.code === 0) {
          this.bannerList = res.data
        }else{
          this.$toast.error(res.msg)
        }
      }).catch(err => {
        this.$toast('请求失败')
        console.log(err, 'err');
      })
    }
  }
}
</script>

<style scoped lang="less">
.home_bottom {
  position: absolute;
  inset: 0;
  background-color: #fff;
  opacity: 0.2;
}
.home_banner {
  height: 30vh;
  // background-color: red;
}
.my-swipe {
  width: 100%;
  height: 100%;
  img {
    width: 100%;
    height: 100%;

  }
}
.van-image {
  height: 100% !important;
}
.home {
  height: 100vh;
  
  .home_option {
    // z-index: 10;
    // width: 70vw;
    padding: 0 40px;
    padding-top: 5vh;
    height: 70vh;
    
    // justify-content: center;

    // transform: translateY(-2vh);
    .item {
      span {
        letter-spacing: 14px;
      }
    }
    .option_item {
      padding: 15px 18px;
      background-color: #fff;
      border-radius: 10px;
      margin-bottom: 30px;
      font-size: 16px;
      letter-spacing: 1px;
      text-align: center;
      box-shadow: 0 0 15px 2px rgba(36, 36, 36, 0.123);

      img {
        width: 13%;
        vertical-align: middle;
        margin-right: 8px;
        &:last-child {
          width: 11%;
        }
      }
    }
  }
}
</style>
